<template>
    <div id="finalizar" class="contentfinish">
        <section class="finish">
            <img src="../assets/logotipo.png" alt="Logotipo Bool" class="mt-5"><br>
            <label>¡Felicidades tu instalación se realizo <br>
                 Correctamente!
            </label><br>
            <router-link to="/calendar">
            <button class="boton" style="float:none !important; margin-top: 3%; margin-left:6%" id="regresar">Regresar</button>
            </router-link>
            <a href="http://bool.abadiati.com/">
            <button class="boton" style="float:none !important; margin-top: 3%;" id="sistema">Ir al sistema</button></a>
        </section>
    </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      stepn: "13-N",
    };
  },
  methods: {
  },
  created() {
  },
};
</script>